export const Divider = () => {
  return (
    <svg
      width="2"
      height="18"
      viewBox="0 0 2 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L0.999998 17"
        stroke="white"
        strokeOpacity="0.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
